import { useCallback, useContext, useState } from "react";
import { AuthContext, AuthContextValue } from "./AuthProvider";

export const useLoginSuperAdmin = (): [
  boolean | null,
  boolean,
  Error | null,
  (email: string, password: string) => void
] => {
  const { authSuperAdmin } = useContext<AuthContextValue>(AuthContext);
  const [result, setResult] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  const request = useCallback(
    async (email: string, password: string) => {
      setIsLoading(true);
      setError(null);

      try {
        await authSuperAdmin(email, password);
        setResult(true);
      } catch (e) {
        if (e instanceof Error) {
          setError(e);
        } else {
          setError(new Error("Unknown error"));
        }
      }
      setIsLoading(false);
    },
    [authSuperAdmin]
  );

  return [result, isLoading, error, request];
};
